import './index.css'

import {Button, Col, Form, Layout, Row, Toast, Tree, Typography, Divider} from "@douyinfe/semi-ui";
import {useEffect, useState} from "react";
import { Tabs, TabPane } from '@douyinfe/semi-ui';
import {CrudOption} from "../../comp/crud";
import {ApiClient, EndTimes, StarTimes, Team} from "../../api/ApiClient";
import { formatDateTime } from '../../utils';

const apiClient = ApiClient.getDefault()
const Title = Typography.Title
interface DayFormProps{
    name: string
    value: string
}

function DayForm(props: DayFormProps){
    return <Form.InputGroup label={{ text: props.name }}>
        <Form.Select style={{width: 80}} field={`${props.value}Start`} noLabel placeholder="上班" optionList={StarTimes.map(t => {
            return {
                label: t,
                value: t
            }
        })} />
        <Form.Select style={{width: 80}} field={`${props.value}End`} noLabel placeholder="下班" optionList={EndTimes.map(t => {
            return {
                label: t,
                value: t
            }
        })} />
        <Form.Checkbox field={`${props.value}Enabled`} style={{marginLeft: 12}} noLabel>上班</Form.Checkbox>
    </Form.InputGroup>
}
export default function PoolSetting(){
    const [teams, setTeams] = useState([] as Team[])
    const getTeamOpts = async () => {
        let teams = await apiClient.getRootTeams()
        setTeams(teams.filter((t) => t.parentId == null))
        return teams
    }

    useEffect(() => {
        getTeamOpts()
        window.document.title = "公共池配置"
    }, [])

    const teamForm = () => {
        return <Tabs type="line">
            {
                teams.map(t => {
                    return <TabPane key={t.id + ""} tab={t.name} itemKey={t.id + ""}>

                        <Form<Team> initValues={t} render={props => {

                            const handleSubmit = async () => {
                                await props.formApi.validate()
                                const values:any = props.formApi.getValues()
                                if(values.ext && values.ext.holidays){
                                    values.ext.holidays = values.ext.holidays.map((t: any) => formatDateTime(t))
                                }
                                await apiClient.request("/teams", 'PUT', null, values)
                                Toast.info("已保存")
                            }
                            return <>
                                <Row gutter={15}>
                                    <Col span={12}>
                                        <Form.Section text="">
                                            <Title heading={6} type='primary'>我的客户</Title>
                                            <Row>
                                                <div style={{display: "none"}}><Form.InputNumber field="id" label="ID" /></div>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.zeroStarsHours" label="0星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.oneStarsHours" label="1星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.twoStarsHours" label="2星" /></Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.threeStarsHours" label="3星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fourStarsHours" label="4星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fiveStarsHours" label="5星" /></Col>
                                            </Row>
                                            <Divider margin='12px'/>
                                            <Title heading={6} type="primary">再分配客户</Title>
                                            <Row>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.zeroStarsHours1" label="0星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.oneStarsHours1" label="1星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.twoStarsHours1" label="2星" /></Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.threeStarsHours1" label="3星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fourStarsHours1" label="4星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fiveStarsHours1" label="5星" /></Col>
                                            </Row>
                                            <Divider margin='12px'/>
                                            <Title heading={6} type='primary'>重要客户</Title>
                                            <Row>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.zeroStarsHours2" label="0星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.oneStarsHours2" label="1星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.twoStarsHours2" label="2星" /></Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.threeStarsHours2" label="3星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fourStarsHours2" label="4星" /></Col>
                                                <Col span={8}><Form.InputNumber labelPosition='left' suffix="小时" field="ext.fiveStarsHours2" label="5星" /></Col>
                                            </Row>
                                        </Form.Section>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Section text="作息时间">
                                            <Row>
                                                <Col span={8}>
                                                    <DayForm name='周一' value='ext.monday' />
                                                </Col>
                                                <Col span={8}>
                                                    <DayForm name='周二' value='ext.tuesday' />
                                                </Col>
                                                <Col span={8}>
                                                    <DayForm name='周三' value='ext.wednesday' />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <DayForm name='周四' value='ext.thursday' />
                                                </Col>
                                                <Col span={8}>
                                                    <DayForm name='周五' value='ext.friday' />
                                                </Col>
                                               
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <DayForm name='周六' value='ext.saturday' />
                                                </Col>
                                                <Col span={8}>
                                                    <DayForm name='周日' value='ext.sunday' />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Form.DatePicker showClear style={{width: "100%"}} multiple label="放假" field='ext.holidays' />
                                                </Col>
                                               
                                            </Row>
                                        </Form.Section>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="center">
                                    <Button onClick={handleSubmit} htmlType="submit">保存</Button>
                                </Row>
                            </>
                        }}>

                        </Form>
                    </TabPane>
                })
            }
        </Tabs>
    }

    return <div className="crud-page">
        <div className="crud-title">
            <Title heading={3}>公共池配置</Title>
        </div>
        <div className="crud-content">
            {
                teams.length == 0 ? null : teamForm()
            }
        </div>
    </div>
}